import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,        // 5 min: navegar entre páginas usa cache
            gcTime: 30 * 60 * 1000,          // 30 min em memória após último uso
            refetchOnWindowFocus: false,     // já temos WS para updates ao vivo
            refetchOnReconnect: 'always',
            retry: (failureCount, error) => {
                const status = error?.response?.status;
                if (status === 401 || status === 403 || status === 404) return false;
                return failureCount < 2;
            },
        },
    },
});

export function installVueQuery(app) {
    app.use(VueQueryPlugin, { queryClient });
}

export { queryClient };
